<script>
// import {getBase64} from '@/utils/Base64Util'
// import MAP_DELAY from '../assets/map_icon/map_delay.png'
import flag from '../../config/api.config'
export default {
  props: {
    // 地图Id
    mapId: {},

    // 地图中心点
    centerPoint: {},

    // 地图上标记点List
    pointList: {},
    EARTH_RADIUS: 6378.137 // 地球半径
  },
  data () {
    return {
      map: {},
      // 地图中心点
      centerPointObj: this.centerPoint,

      // 地图上标记点List
      pointListObj: this.pointList,
      markerPoint: null
    }
  },
  watch: {
    'pointList' (obj) {
      this.pointListObj = obj
    }
  },
  methods: {
    // 初始化一个只有中心点的地图.
    initializeGoogleMap () {
      var self = this
      var promise = new Promise((resolve, reject) => {
        // self.centerPointObj = self.centerPoint
        // self.pointListObj = self.pointList
        var mapUrl = sessionStorage.getItem('googleMapUrl')
        this.loadGoogleMapScript(mapUrl).then(() => {
          self.map = self.createGoogleMap()
          if (self.map != null) {
            resolve()
          } else {
            reject(new Error('MAP_ERROR'))
          }
        })
      })
      return promise
    },
    // 加载URL
    loadGoogleMapScript: function (src) {
      var promise = new Promise((resolve, reject) => {
        if (!global.google) {
          const $script = document.createElement('script')
          global.document.body.appendChild($script)
          $script.src = src
          // script节点加载成功
          $script.onload = () => {
            $script.onload = null
            // 地图js加载成功
            if (global.google) {
              resolve()
            } else {
              // 地图js加载失败（例如key无效等）
              reject(new Error('MAP_ERROR'))
            }
          }
          // script节点加载失败
          $script.onerror = () => {
            $script.onload = null
            reject(new Error('MAP_ERROR'))
          }
        } else {
          resolve()
        }
      })
      return promise
    },
    // 创建GoogleMap
    createGoogleMap () {
      // 设置默认地址
      if (this.centerPointObj.lat === null || this.centerPointObj.lat === undefined ||
      this.centerPointObj.lng === null || this.centerPointObj.lng === undefined) {
        this.centerPointObj.lat = parseFloat(sessionStorage.getItem('mapCenterDefaultLat'))
        this.centerPointObj.lng = parseFloat(sessionStorage.getItem('mapCenterDefaultLng'))
      }
      var map = new global.google.maps.Map(
        document.getElementById(this.mapId),
        {
          zoom: 12,
          center: this.centerPointObj,
          // 去除自带按钮
          disableDefaultUI: true
        }
      )
      return map
    },
    // 绘制图标
    // imgSize 图片大小{width,height}
    // labelClass 定义在googleMap上label的样式
    // labelAnchor label的位置{width,height}
    // clickable 点是否可点击
    addMark (imgSize, labelClass, labelAnchor, clickable) {
      let markList = []
      let mClickable = false
      if (clickable) {
        mClickable = clickable
      }
      for (let i = 0; i < this.pointListObj.length; i++) {
        // 设置自定义图标
        let img
        let iconSize
        let labelCss
        let labelAnch
        if (this.pointListObj[i].labelClass) {
          labelCss = this.pointListObj[i].labelClass
        } else {
          labelCss = labelClass
        }
        if (this.pointListObj[i].iconSize) {
          iconSize = this.pointListObj[i].iconSize
        } else {
          iconSize = imgSize
        }

        if (this.pointListObj[i].labelAnchor) {
          labelAnch = this.pointListObj[i].labelAnchor
        } else {
          labelAnch = labelAnchor
        }

        if (this.pointListObj[i].icon && iconSize) {
          img = {
            url: this.pointListObj[i].icon,
            size: new global.google.maps.Size(iconSize.width, iconSize.height),
            origin: new global.google.maps.Point(0, 0),
            anchor: new global.google.maps.Point(iconSize.width / 2, iconSize.height),
            scaledSize: new global.google.maps.Size(iconSize.width, iconSize.height)
          }
        }

        let MarkerWithLabel = require('@/utils/MarkLabelUtil')(global.google.maps)

        let pointLatLng = new global.google.maps.LatLng(this.pointListObj[i].stationLat, this.pointListObj[i].stationLng)

        let marker = new MarkerWithLabel({
          position: pointLatLng,
          map: this.map,
          draggable: false,
          raiseOnDrag: true,
          clickable: mClickable,
          icon: img,
          labelContent: this.pointListObj[i].stationId,
          labelAnchor: !labelAnch ? new global.google.maps.Point(iconSize.width / 2, iconSize.height / 2) : new global.google.maps.Point(labelAnch.width, labelAnch.height),
          labelClass: !labelCss ? '' : labelCss, // the CSS class for the label
          labelInBackground: false,
          labelStyle: {width: iconSize.width + 'px'}
        })

        markList.push(marker)
      }
      return markList
    },
    // 动态绘制图表
    addDynMark (oldMarkList, pointList) {
      for (let marker of oldMarkList) {
        marker.setMap(null)
      }
      let markList = []
      for (let i = 0; i < this.pointListObj.length; i++) {
        let point = {
          label: this.pointListObj[i].stationId,
          lat: this.pointListObj[i].stationLat,
          lng: this.pointListObj[i].stationLng
        }
        // 设置自定义图标Base64
        let img
        if (this.pointListObj[i].icon !== undefined) {
          img = {
            url: this.pointListObj[i].icon,
            size: new global.google.maps.Size(40, 40),
            origin: new global.google.maps.Point(0, 0),
            anchor: new global.google.maps.Point(17, 34),
            scaledSize: new global.google.maps.Size(40, 40)
          }
        }

        let marker = new global.google.maps.Marker({
          position: point,
          label: point.label,
          map: this.map,
          icon: img
        })
        markList.push(marker)
      }
      return markList
    },
    // 地图单击事件
    addDoubleClickEvent (markPosition, imgSize) {
      global.google.maps.event.addListener(this.map, 'click', event => {
        var eventObj = {}
        const lnglat = { lng: event.latLng.lng(), lat: event.latLng.lat() }
        // 通过vuex把经纬度全局共享
        window.vm.$store.commit('SET_LNGLAT', { markPosition: lnglat })
        eventObj.lat = event.latLng.lat()
        eventObj.lng = event.latLng.lng()
        this.searchAddressInfoProcess(eventObj, markPosition, imgSize)
      })
    },
    // 添加单个标记
    // markPosition = {
    // lat: this.shiftInfo.vehicleLat,
    // lng: this.shiftInfo.vehicleLng,
    // icon: icon}
    // imgSize  图标的大小
    searchAddressInfoProcess (latLng, markPosition, imgSize) {
      var eventObj = {}
      let pointLatLng = null
      if (latLng == null && markPosition.lat != null) {
        eventObj.lat = markPosition.lat
        eventObj.lng = markPosition.lng
        pointLatLng = new global.google.maps.LatLng(markPosition.lat, markPosition.lng)
      } else {
        eventObj.lat = latLng.lat
        eventObj.lng = latLng.lng
        pointLatLng = new global.google.maps.LatLng(eventObj.lat, eventObj.lng)
      }
      // 在此根据以上数据,搜索街道信息
      this.getAddressInfo(latLng).then(addressObj => {
        if (addressObj != null) {
          eventObj.placeName = addressObj.placeName
          eventObj.address = addressObj.address
          eventObj.postCode = addressObj.postCode
        } else {
          eventObj.placeName = ''
          eventObj.address = ''
          if (latLng === null) {
            eventObj.postCode = markPosition.postCode !== undefined ? markPosition.postCode : ''
          } else {
            eventObj.postCode = ''
          }
        }
        if (this.markerPoint != null) {
          this.markerPoint.setMap(null)
        }
        let MarkerWithLabel = require('@/utils/MarkLabelUtil')(global.google.maps)
        let img = {
          url: markPosition.icon,
          size: new global.google.maps.Size(imgSize.width, imgSize.height),
          origin: new global.google.maps.Point(0, 0),
          anchor: new global.google.maps.Point(imgSize.width / 2, imgSize.height),
          scaledSize: new global.google.maps.Size(imgSize.width, imgSize.height)
        }

        this.markerPoint = new MarkerWithLabel({
          position: pointLatLng,
          map: this.map,
          icon: img
        })
        // this.markerPoint = new global.google.maps.Marker({
        //   position: latLng,
        //   map: this.map
        // })
        this.$emit('mapLeftClickEvent', eventObj)
      })
    },
    // 根据经纬度搜索地址信息
    getAddressInfo (latLng) {
      return new Promise((resolve, reject) => {
        if (latLng == null || latLng === undefined) {
          resolve(null)
        }
        var geocoder = new global.google.maps.Geocoder()
        geocoder.geocode({ location: latLng }, (results, status) => {
          if (status === 'OK') {
            var addressObj = {
              placeName: '',
              address: ''
            }
            if (results[0]) {
              // true: 生产环境, fasle: 开发环境
              if (flag.isPro) {
                // let formattedAddress = '日本、〒728-0011 広島県三次市十日市西１丁目８?３０ なかやま美容室'
                // let formattedAddress = '日本、某某車站'
                // let formattedAddress = 'Unnamed Road, １丁目 十日市西 三次市 広島県 728-0011 日本'
                let formattedAddress = results[0].formatted_address

                if (formattedAddress.startsWith('日本')) {
                  let address = formattedAddress.split(' ')
                  if (address.length > 1) {
                    addressObj.placeName = address[2]
                    addressObj.address = address[1]
                  } else {
                    addressObj.placeName = ''
                    addressObj.address = address[1] || ''
                  }
                  // addressObj里字段屬性 為空.
                  if (addressObj.placeName === '' && addressObj.address === '') {
                    let address = formattedAddress.split('、')
                    // 利用扩展运算符 把数组拆分成两等分
                    const [first, ...option] = address
                    // 数组转换成字符串
                    addressObj.placeName = ''
                    addressObj.address = option.toString() || ''
                    // addressObj.first = first
                  }
                } else {
                  let address = formattedAddress.split(',')
                  if (address.length > 1) {
                    addressObj.placeName = ''
                    addressObj.address = address[1]
                  } else {
                    addressObj.placeName = ''
                    addressObj.address = ''
                  }
                  // addressObj里字段屬性 為空
                  if (addressObj.placeName === '' && addressObj.address === '') {
                    addressObj.placeName = ''
                    addressObj.address = formattedAddress || ''
                  }
                }
                // let address = falg[0].address_components
              } else {
                let addressArray = results[0].formatted_address.split(',')

                if (addressArray.length > 4) {
                  let lastStr = addressArray[addressArray.length - 1].split(' ')
                  if (lastStr[lastStr.length - 1] !== 'Japan') {
                    addressObj.placeName = lastStr[lastStr.length - 1]
                  } else {
                    addressObj.placeName = ''
                  }
                } else {
                  addressObj.placeName = ''
                }
                if (addressArray.length >= 2) {
                  addressObj.address = results[0].formatted_address
                } else {
                  // addressObj.address = ''
                  addressObj.address = results[0].formatted_address
                }
              }
              let len = results[0].address_components.length
              let postCode = results[0].address_components[len - 1].short_name
              if (postCode !== undefined && postCode !== '') {
                if (/^\d{3}-?\d{4}$/.test(postCode)) {
                  addressObj.postCode = postCode
                } else {
                  addressObj.postCode = ''
                }
              } else {
                addressObj.postCode = ''
              }
              resolve(addressObj)
            } else {
              reject(new Error('MAP_ERROR'))
            }
          } else {
            reject(new Error('MAP_ERROR'))
          }
        })
      })
    },
    // 根据输入地址搜索并定位地址
    seachAndLocatePlaceProcess (address) {
      var geocoder = new global.google.maps.Geocoder()
      var promise = new Promise((resolve, reject) => {
        geocoder.geocode({ address: address }, (results, status) => {
          if (status === 'OK') {
            this.map.setCenter(results[0].geometry.location)
            this.map.setZoom(12)
            if (this.markerPoint != null) {
              this.markerPoint.setMap(null)
            }
            this.markerPoint = new global.google.maps.Marker({
              map: this.map,
              position: results[0].geometry.location
            })
            resolve(results[0].geometry.location)
          } else {
            reject(new Error('MAP_ERROR'))
          }
        })
      })
      return promise
    },

    /**
     *  添加单个标记
     *  @param markPosition  // 点坐标 四个参数 label: 里面填充内容， lng、lat 经纬度，icon: 图标具体路径 import导入。
     *  @param imgSize       // 图标的大小
     *  @param labelClass    // 图标里面字体的样式的类名 在最下面定义
     *  @param labelAnchor   // 图标里面字体的位置
     *  markPosition = {
     *  label: null,
     *  lat: this.shiftInfo.vehicleLat,
     *  lng: this.shiftInfo.vehicleLng,
     *  icon: icon
     *  iconSize: iconSize}
     *  imgSize  图标的大小
     *  labelClass 图标里面字体的样式的类名 在最下面定义
     *  labelAnchor 图标里面字体的位置
     *  clickable 是否能点击
     * }
    */
    addSingleMaker (markPosition, imgSize, labelClass, labelAnchor) {
      if (this.markerPoint != null) {
        this.markerPoint.setMap(null)
      }
      // 设置自定义图标
      let img
      let iconSize
      let labelCls
      if (imgSize) {
        iconSize = imgSize
      }
      let mClickable = false
      if (markPosition.clickable) {
        mClickable = markPosition.clickable
      }

      if (markPosition.labelClass) {
        labelCls = markPosition.labelClass
      } else {
        labelCls = labelClass
      }

      if (markPosition.iconSize) {
        iconSize = markPosition.iconSize
      }
      if (markPosition.icon && iconSize) {
        img = {
          url: markPosition.icon,
          size: new global.google.maps.Size(iconSize.width, iconSize.height),
          origin: new global.google.maps.Point(0, 0),
          anchor: new global.google.maps.Point(iconSize.width / 2, iconSize.height),
          scaledSize: new global.google.maps.Size(iconSize.width, iconSize.height)
        }
      }

      let MarkerWithLabel = require('@/utils/MarkLabelUtil')(global.google.maps)

      let pointLatLng = new global.google.maps.LatLng(markPosition.lat, markPosition.lng)

      let marker = new MarkerWithLabel({
        position: pointLatLng,
        map: this.map,
        draggable: false,
        raiseOnDrag: true,
        clickable: mClickable,
        icon: img,
        labelContent: markPosition.label,
        labelAnchor: !labelAnchor ? new global.google.maps.Point(iconSize.width / 2, iconSize.height / 2) : new global.google.maps.Point(labelAnchor.width, labelAnchor.height),
        labelClass: !labelCls ? '' : labelCls, // the CSS class for the label
        labelInBackground: false,
        labelStyle: {width: iconSize.width + 'px'}
      })
      return marker
    },
    // 绘制线
    drawLine (pointList) {
      for (let i = 0; i + 1 < pointList.length; i++) {
        let param = [pointList[i], pointList[i + 1]]
        this.$axios.post('route/getRouteDataFromApi', {viewModelData: param})
          .then((response) => {
            let flightPlanCoordinates = response.data.routeApiData.overviewPath
            // 画线
            let flightPath = new global.google.maps.Polyline({
              path: flightPlanCoordinates,
              geodesic: true,
              strokeColor: '#106BD8',
              strokeOpacity: 1.0,
              strokeWeight: 6
            })
            flightPath.setMap(this.map)
          })
          .catch((error) => {
            console.log(error)
          })
      }
    },
    plannRoute (stayPoint) {
      return new Promise((resolve, reject) => {
        var sum = [] // 保存每个地点的时间距离
        var waypts = [] // 保存经由地
        var totalDistance = 0// 总路程
        var totalTime = 0// 总时间
        // 循环保存对象
        for (let index = 1; index < stayPoint.length - 1; index++) {
          const point = stayPoint[index]
          waypts.push({
            location: point,
            stopover: true
          })
        }
        var directionsDisplay = new global.google.maps.DirectionsRenderer({
          map: this.map
        })
        var directionsService = new global.google.maps.DirectionsService()
        var request = {
          origin: stayPoint[0], // 起点
          destination: stayPoint[stayPoint.length - 1], // 终点
          waypoints: waypts, // 经由地
          // optimizeWaypoints: true, // 路线优化
          travelMode: 'DRIVING' // 行驶方式
        }
        directionsDisplay.setOptions({
          polylineOptions: {
            // 粗细
            strokeWeight: 5,
            preserveViewport: true,
            // 透明度(0.0~1.0)
            strokeOpacity: 1.0, // 颜色
            strokeColor: ' #0072d1'
          },
          suppressMarkers: true// 不显示点
        })
        directionsService.route(request, (response, status) => {
          if (status === global.google.maps.DirectionsStatus.OK) {
            directionsDisplay.setDirections(response)
            response['routes'][0].legs.forEach(item => {
              var distanceVaue = item.distance.value
              var durationVaue = item.duration.value
              if (distanceVaue / 100 > 1000) {
                distanceVaue = Math.round(distanceVaue / 1000)
              } else {
                distanceVaue = Math.round(distanceVaue / 100) / 10
              }
              totalDistance += distanceVaue
              totalTime += durationVaue
              sum.push({
                durationText: item.duration.text,
                distanceText: item.distance.text,
                distanceVaue: distanceVaue,
                durationVaue: durationVaue
              })
            })
            sum.push({
              totalDistance: totalDistance,
              totalTime: totalTime
            })
          }
          // 执行成功
          resolve(sum)
        })
      })
    },
    // 将用角度表示的角转换为近似相等的用弧度表示的角 java Math.toRadians
    rad (d) {
      return d * Math.PI / 180.0
    },

    /**
     * 谷歌地图计算两个坐标点的距离
     * @param lng1  经度1
     * @param lat1  纬度1
     * @param lng2  经度2
     * @param lat2  纬度2
     * @return 距离（千米）
     */
    getDistance (lng1, lat1, lng2, lat2) {
      var lat = [lat2, lat1]
      var lng = [lng2, lng1]
      var R = 6378137
      var dLat = (lat[1] - lat[0]) * Math.PI / 180
      var dLng = (lng[1] - lng[0]) * Math.PI / 180
      var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.cos(lat[0] * Math.PI / 180) * Math.cos(lat[1] * Math.PI / 180) * Math.sin(dLng / 2) * Math.sin(dLng / 2)
      var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))
      var d = R * c
      return Math.round(d / 1000)
    },
    /** 根据距离获取合适的比例尺 */
    getScaleLevel (distance) {
      console.log(distance)
      let level
      if (distance >= 5000) {
        level = 2
      } else if (distance >= 2000) {
        level = 4
      } else if (distance >= 1000) {
        level = 5
      } else if (distance >= 500) {
        level = 6
      } else if (distance >= 200) {
        level = 7
      } else if (distance >= 100) {
        level = 8
      } else if (distance >= 50) {
        level = 9
      } else if (distance >= 20) {
        level = 10
      } else if (distance >= 10) {
        level = 12
      } else if (distance >= 5) {
        level = 13
      } else {
        level = 14
      }
      return level
    }

  }
}
</script>

<template>
  <div v-bind:id="this.mapId" ></div>
</template>

<style>
#mapReg {
  width: 100%;
  height: 100%;
}
#mapSave {
  width: 540px;
  height: 450px;
}
#mapStation {
  width: 100%;
  height: 100%;
}
#mapMovementShiftDetail{
  width: 100%;
  height: 100%;
}
#mapMovementStatus{
  width: 100%;
  height: 100%;
}
#mapMovementStatusDetail{
  width: 100%;
  height: 100%;
}
#mapChoice{
  width: 100%;
  height: 500px;
}
#mapStationDetail {
  width: 100%;
  height: 100%;
}
#home{
   width: 100%;
  height: 500px;
}
#stayPlace{
  width: 100%;
  height: 580px;
}
#stationPlace{
  width: 100%;
  height: 500px;
}
#mapShow {
  width: 100%;
  height: 500px;
}
#autoAdressMap {
  width: 100%;
  height: 50px;
}

/* label 样式 */
.movement-status-label-class {
  color: white;
  font-family: 'Noto Sans CJK JP';
  font-size: 10px;
  font-weight: bold;
  text-align: center;
  white-space: nowrap;
}

.station-label-class-1 {
  color: rgb(65,147,159);
  font-weight: bold;
  font-size: 20px;
}
.station-label-class-2 {
  color: rgb(180,220,230);
  font-weight: bold;
  font-size: 20px;
}

/* ルート地图图标里字体样式 */
.route-label-class {
  color: rgb(65,147,159);
  font-weight: 400;
  font-size: 25px;
}
.staion01-label-class {
  color: rgb(65,147,159);
  font-weight: 400;
  font-size: 35px;
}
.staion02-label-class {
  color: #b4dce6;
  font-weight: 400;
  font-size: 25px;
}
.staion03-label-class {
  color: rgb(65,147,159);
  font-weight: 400;
  font-size: 25px;
}
</style>



// WEBPACK FOOTER //
// src/components/googleMap.vue